import pluginErrorHandler from "@stadium/services/plugin-error-handler";

import {
  ZENDESK_DEFAULT_ZINDEX,
  ZENDESK_ZINDEX_VALUE_FOR_HIDING,
} from "@stadium/services/zendesk/constants";

class Zendesk {
  constructor() {
    try {
      window.zE = new Proxy(window.zE, pluginErrorHandler);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, "Zendesk is not initialized");
    }
  }

  hideIcon = () => {
    window.zE?.("messenger", "hide");
  };

  showIcon = () => {
    window.zE?.("messenger", "show");
  };

  show = () => {
    window.zE?.("messenger", "open");
    this.toggleLauncher({ hide: false });
  };

  close = () => {
    window.zE?.("messenger", "close");
  };

  toggleLauncher = ({ hide = true }) => {
    window.zE?.(
      "messenger:set",
      "zIndex",
      hide ? ZENDESK_ZINDEX_VALUE_FOR_HIDING : ZENDESK_DEFAULT_ZINDEX,
    );
  };
}

const zendeskService = typeof window !== "undefined" ? new Zendesk() : "";

export default zendeskService;
